<template>
  <b-modal v-model="showModal" centered hide-footer hide-header lazy>
    <div class="card p-md-4 p-2">
      <div class="mb-2 d-flex justify-content-between">
        <h3>{{ $t('message.disabledDevice.topic') }}</h3>
        <b-button @click="showModal = false" variant="transparent" class="px-0 py-0">
          <svg-icon name="x" class="fill-icon" size="20"></svg-icon>
        </b-button>
      </div>
      <div class="py-4">
        <p class="success-message text-danger subtitle">
          {{ $t('message.disabledDevice.title') }}
        </p>
      </div>
      <div>
        <p class="text-muted subtitle">
          {{ $t('message.disabledDevice.subTitle') }}
          <a class="text-muted" :href="'tel:' + SUPPORT_PHONE_NUMBER">{{ SUPPORT_PHONE_NUMBER }}</a>
        </p>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { SUPPORT_PHONE_NUMBER } from '@/utils/const.js';

export default {
  name: 'TemporaryDisabledDeviceModal',
  props: {
    value: {
      type: Boolean,
    },
  },
  computed: {
    showModal: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit('input', v);
      },
    },
  },
  data() {
    return {
      SUPPORT_PHONE_NUMBER,
    };
  },
};
</script>

<style lang="scss" scoped>
.card {
  background-color: #17181d;
}
</style>
